/*eslint-env browser*/


/*

To make it work, you have to init with "setAbsolutePath", or your html page should have a meta with the absolute path to client files on your computer.

Example:
<meta name="linkToCodeEditorAbsolutePath" content="/User/plancien/projects/explorers/scripts/" />


See these links
Atom on MacOS :        https://github.com/WizardOfOgz/atom-handler
Atom on Windows :      https://github.com/UziTech/atom-url-handler
SublimeText on Linux : https://github.com/eclemens/atom-url-handler

*/


let absolutePathPrefix
let codeEditorName = "textmate"
let absolutePathPrefixFromMeta = null


let onLocalHost = (typeof window !== "undefined" && (window.location.protocol === "file:" || window.location.hostname === "localhost"))


function setAbsolutePathPrefixFromMetaIfNeeded () {
    if (!document && !absolutePathPrefix && absolutePathPrefixFromMeta !== null) {
        return
    }

    let metaElement = document.querySelector("meta[name=linkToCodeEditorAbsolutePath]")
    absolutePathPrefixFromMeta = metaElement && metaElement.getAttribute("content")

    if (absolutePathPrefixFromMeta) {
        absolutePathPrefix = absolutePathPrefixFromMeta
    }
}



function setAbsolutePath (path) {
    absolutePathPrefix = path
}


function setCodeEditorName (name) {
    codeEditorName = name
}


let urlFor = {
    vscode: vscodeUrl,
    textmate: textmateUrl
}


function vscodeUrl (filePath, lineNumber, columnNumber) {
    let link = `vscode://file/${absolutePathPrefix}${filePath}`

    if (typeof lineNumber !== "undefined" && typeof columnNumber !== "undefined") {
        link += `:${lineNumber}:${columnNumber}`
    }

    return link
}


function textmateUrl (filePath, lineNumber, columnNumber) {
    let link = `txmt://open?url=file://${absolutePathPrefix}${filePath}`

    if (typeof lineNumber !== "undefined") {
        link += `&line=${lineNumber}`
    }

    if (typeof columnNumber !== "undefined") {
        link += `&column=${columnNumber}`
    }

    return link
}


function codeEditorUrl (filePath, lineNumber, columnNumber) {
    return urlFor[codeEditorName](filePath, lineNumber, columnNumber)
}



let noConfigWarningDisplayed = true

function fromRelativeUrl (relativeUrl, text) {
    setAbsolutePathPrefixFromMetaIfNeeded()

    if (!absolutePathPrefix) {
        if (onLocalHost && noConfigWarningDisplayed) {
            noConfigWarningDisplayed = false
            console.warn("Toxilib LinkToCodeEditor could not find your editor config. Links to open files in your code editor will be disabled. Read the top of the link_to_code_editor.js to learn how to configure.")
        }
        return relativeUrl
    }

    return relativeUrl.replace(/(.*):(\d*):(\d*)/, function (fullMatch, filePath, lineNumber, columnNumber) {
        return `<a class="linkToCodeEditor" href="${linkToCodeEditor.url(filePath, lineNumber, columnNumber)}">${text || relativeUrl}</a>`
    })

}




const linkToCodeEditor = {
    setCodeEditorName,
    setAbsolutePath,
    fromRelativeUrl
}

linkToCodeEditor.url = codeEditorUrl

export default linkToCodeEditor
